// extracted by mini-css-extract-plugin
export default {"wrapper":"RenderedHtmlWithPopup_wrapper__oy3bq","popupPaper":"RenderedHtmlWithPopup_popupPaper__+PBT8","popupContent":"RenderedHtmlWithPopup_popupContent__nksLM"};